let locale = 'fr';

export const setLocale = (newLocale: string) => {
  locale = newLocale;
};

export const getLocale = () => locale;
